import { render, staticRenderFns } from "./ProductAddAction.vue?vue&type=template&id=20745a2e"
import script from "./ProductAddAction.vue?vue&type=script&lang=js"
export * from "./ProductAddAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports